import React from "react"

import { useFormContext } from "react-hook-form"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config.ts"
import { InputElement } from "@front-shared/elements/input.element.tsx"

import type { IDynamicCheckerFormInputData } from "../../../../types/data.types.ts"

export const AgenticTaxIdRenderingNameInput: React.FunctionComponent<
    IAgenticTaxIdRenderingNameInputProps
> = props => {
    const {
        control,
        formState: { errors },
    } = useFormContext<IDynamicCheckerFormInputData>()

    return (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            <div className="flex md:block">
                <InputElement
                    className="
                        mr-[24px] flex-1
                        md:mr-[0px]
                    "
                    label="Billing Provider Tax ID"
                    name="providerTaxId"
                    placeholder="123456789"
                    reactHookErrors={errors}
                    reactHookControl={control as any}
                    reactHookValidations={{
                        required: FRONT_VALIDATION_CONFIG.required,
                        pattern: FRONT_VALIDATION_CONFIG.taxId,
                    }}
                    defaultValue={props.formDefaultValues?.providerTaxId}
                    isLabelStatic
                />

                <InputElement
                    className="flex-1 md:mt-[40px]"
                    label="Rendering Provider Name"
                    name="renderingProviderName"
                    reactHookErrors={errors}
                    reactHookControl={control as any}
                    reactHookValidations={{
                        required: FRONT_VALIDATION_CONFIG.required,
                        maxLength: FRONT_VALIDATION_CONFIG.maxLength,
                    }}
                    defaultValue={
                        props.formDefaultValues?.renderingProviderName
                    }
                    isLabelStatic
                />
            </div>
        </div>
    )
}

interface IAgenticTaxIdRenderingNameInputProps {
    className?: string
    formDefaultValues?: IDynamicCheckerFormInputData
}
